/**
 * Bewertungsbitte (Migration 192): Google-Link und die kurze Standardmail.
 *
 * Die Mail entsteht beim Projektabschluss als Aufgabe. {persoenlich} sind die
 * ein, zwei Sätze, die Clara aus dem Projektgedächtnis ergänzt — ist sie nicht
 * erreichbar, fällt der Absatz einfach weg.
 */
import { useState } from "react";
import { fehlerText } from "@vimaana/ui";

import { useBewertungEinstellung, useBewertungEinstellungSpeichern } from "../../hooks/useBewertung";
import "../../styles/kalenderabo.css";
import "../../styles/bewertung.css";

const ERKLAERUNG: Record<string, string> = {
  anrede: "Anrede des Kunden",
  projekt: "Projektname in Anführungszeichen (bei Pflege: „der Pflege Ihres Gartens“)",
  persoenlich: "Claras ein, zwei Sätze",
  link: "der Google-Link",
};

export default function BewertungEinstellung() {
  const q = useBewertungEinstellung();
  const speichern = useBewertungEinstellungSpeichern();
  const [link, setLink] = useState<string | null>(null);
  const [betreff, setBetreff] = useState<string | null>(null);
  const [text, setText] = useState<string | null>(null);
  const d = q.data;
  const werte = { link: link ?? d?.link ?? "", betreff: betreff ?? d?.betreff ?? "", text: text ?? d?.text ?? "" };
  const geaendert = !!d && (werte.link !== d.link || werte.betreff !== d.betreff || werte.text !== d.text);
  const zuruecksetzen = () => { setLink(null); setBetreff(null); setText(null); };

  return (
    <section className="ka-card">
      <div className="ka-h2">Bewertungsbitte</div>
      <p className="ka-text">
        Ist ein Projekt abgeschlossen, steht in „Aufgaben“ die Karte „Bewertung erbitten“ mit dieser Mail. Jeder Kunde wird nur einmal gefragt.
      </p>
      {q.isLoading && <p className="ka-text ka-leise">Lädt …</p>}
      {q.error && <p className="ka-fehler">{fehlerText(q.error)}</p>}
      {d && (
        <>
          <label className="bw-feld">
            Google-Bewertungslink
            <input type="url" value={werte.link} onChange={(e) => setLink(e.target.value)} placeholder="https://g.page/r/…/review" />
          </label>
          <label className="bw-feld">
            Betreff
            <input type="text" value={werte.betreff} onChange={(e) => setBetreff(e.target.value)} />
          </label>
          <label className="bw-feld">
            Text
            <textarea value={werte.text} onChange={(e) => setText(e.target.value)} />
          </label>
          <p className="bw-leise">
            Platzhalter: {d.platzhalter.map((p, i) => (
              <span key={p}>{i > 0 ? " · " : ""}<code>{`{${p}}`}</code> {ERKLAERUNG[p] || ""}</span>
            ))}. Die Signatur hängt das Postfach an.
          </p>
          <div className="bw-leiste">
            <button type="button" className="vg-btn vg-btn-primary" disabled={!geaendert || speichern.isPending}
              onClick={() => speichern.mutate(werte, { onSuccess: zuruecksetzen })}>
              {speichern.isPending ? "Speichert …" : "Speichern"}
            </button>
            {d.eigen && (
              <button type="button" className="vg-btn vg-btn-ghost" disabled={speichern.isPending}
                onClick={() => speichern.mutate({ link: werte.link, betreff: "", text: "" }, { onSuccess: zuruecksetzen })}>
                Standardtext
              </button>
            )}
            {speichern.isSuccess && !geaendert && <span className="bw-leise">Gespeichert.</span>}
            {speichern.error && <span className="ka-fehler">{fehlerText(speichern.error)}</span>}
          </div>
        </>
      )}
    </section>
  );
}
